import { Box } from "@mui/material";
import { useState } from "react";

import { Option } from "api/common/types/common.types";
import { formContext, useAppForm } from "components/Forms/AppForm";
import Subheader from "components/Subheader";
import { usePageTitle } from "hooks/usePageTitle";
import { useSearchIntercept } from "hooks/useSearchIntercept";

import PclControls from "./components/Controls/PclControls";
import PclFilter from "./components/Filter/PclFilter";
import ProductGridView from "./components/GridView/ProductGridView";
import HeaderInfo from "./components/Header/HeaderInfo";
import PclHeader from "./components/Header/PclHeader";
import ProductListView from "./components/ListView/ProductListView";
import PclModals from "./components/Modals/PclModals";
import ProductTableView from "./components/TableView/ProductTableView";
import { PclContextProvider } from "./context/PclContextProvider";

import "components/Products/Products.css";

export type PclDisplayType = "Table" | "Grid" | "List";

export type MaintenanceFilterOption =
  | "All"
  | "OnlyMaintenances"
  | "NoMaintenances";
export interface PclFilterOptions {
  search: string;
  techType: Option;
  vendor: Option;
  protectionProfile: Option;
  country: Option;
  status: string;
  hasMaintenance: MaintenanceFilterOption;
}

const defaultFilterValues: PclFilterOptions = {
  search: "",
  techType: { value: "", label: "" },
  vendor: { value: "", label: "" },
  protectionProfile: { value: "", label: "" },
  country: { value: "", label: "" },
  status: "Certified",
  hasMaintenance: "All",
};

export default function Products() {
  const [showFilters, setShowFilters] = useState(true);

  const [productsView, setProductsView] = useState<PclDisplayType>("Table");

  const filterForm = useAppForm({
    defaultValues: defaultFilterValues,
  });

  usePageTitle("NIAP - Products");

  useSearchIntercept({
    onSearch: () => setShowFilters(true),
    disableNative: true,
  });

  const handleProductDisplay = (view: PclDisplayType) => {
    setProductsView(view);
    setShowFilters(false);
  };

  const toggleFilter = () => setShowFilters(!showFilters);

  return (
    <formContext.Provider value={filterForm}>
      <PclContextProvider>
        <Subheader pageName={"Products"} />

        <Box padding={1}>
          <PclHeader />

          <PclModals />

          <HeaderInfo />

          <PclControls
            showFilters={showFilters}
            productsView={productsView}
            handleShowFilter={toggleFilter}
            onDisplayChange={handleProductDisplay}
          />

          <Box display="flex" padding={1} height={"100%"}>
            <PclFilter show={showFilters} />

            {productsView === "Grid" && <ProductGridView />}
            {productsView === "List" && <ProductListView />}
            {productsView === "Table" && <ProductTableView />}
          </Box>
        </Box>
      </PclContextProvider>
    </formContext.Provider>
  );
}
